import { SERVER } from "./server.config";

export enum TagType {
  Location = "Location",
  Auth = "Auth",
  VerificationCode = "VerificationCode",
  Restaurant = "Restaurant",
  Item = "Item",
  Order = "Order",
  RestaurantRequest = "RestaurantRequest",
  RiderRequest = "RiderRequest",
  Ad = "Ad",
  UserAddress = "UserAddress",
  UserProfile = "UserProfile",
}

export const APIS = {
  LOCATION: {
    reducerPath: "locations",
    baseUrl: `${SERVER.URL}/locations`,
    tagTypes: [TagType.Location],
  },
  AUTH: {
    reducerPath: "auth",
    baseUrl: `${SERVER.URL}/auth`,
    tagTypes: [TagType.Auth],
  },
  VERIFICATION_CODE: {
    reducerPath: "verification-code",
    baseUrl: `${SERVER.URL}/verification-token`,
    tagTypes: [TagType.VerificationCode],
  },
  RESTAURANT: {
    reducerPath: "restaurants",
    baseUrl: `${SERVER.URL}/restaurants`,
    tagTypes: [TagType.Restaurant],
  },
  ITEM: {
    reducerPath: "items",
    baseUrl: `${SERVER.URL}/items`,
    tagTypes: [TagType.Item],
  },
  ORDER: {
    reducerPath: "orders",
    baseUrl: `${SERVER.URL}/orders`,
    tagTypes: [TagType.Order],
  },
  RESTAURANT_REQUEST: {
    reducerPath: "restaurant-requests",
    baseUrl: `${SERVER.URL}/restaurant-requests`,
    tagTypes: [TagType.RestaurantRequest],
  },
  RIDER_REQUEST: {
    reducerPath: "rider-requests",
    baseUrl: `${SERVER.URL}/rider-requests`,
    tagTypes: [TagType.RiderRequest],
  },
  AD: {
    reducerPath: "ads",
    baseUrl: `${SERVER.URL}/ads`,
    tagTypes: [TagType.Ad],
  },
  USER: {
    reducerPath: "users",
    baseUrl: `${SERVER.URL}/users`,
    tagTypes: [TagType.UserAddress, TagType.UserProfile],
  },
};

export const {
  LOCATION,
  AUTH,
  VERIFICATION_CODE,
  RESTAURANT,
  ITEM,
  ORDER,
  RESTAURANT_REQUEST,
  RIDER_REQUEST,
  AD,
  USER,
} = APIS;
